import React, { useEffect, useState } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useTheme } from "react-native-paper";
import CustomHeader from "./CustomHeader";
import Access from "../pages/Home/Access";
import i18n from "../i18n";
import { mobUser } from "../mobx/MobUser";
import { observer } from "mobx-react";

const AccessTabNavigator = createNativeStackNavigator();

interface Route {
  name: string,
  component: () => JSX.Element,
  headerTitle: string,
  headerHasArrow: boolean
}

const AccessTabScreen = observer(() => {
  const theme = useTheme();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, [mobUser.Language]);

  const ROUTE: Route = { name: "Access", component: Access, headerTitle: i18n.t("home.access"), headerHasArrow: false };

  return (
    <AccessTabNavigator.Navigator
      key={key}
      screenOptions={{
        statusBarColor: theme.colors.primary,
        navigationBarHidden: false,
        contentStyle: {
          backgroundColor: theme.colors.background
        }
      }}
    >
      <AccessTabNavigator.Screen
        name={ROUTE.name}
        component={ROUTE.component}
        options={{
          header: () => CustomHeader({ text: ROUTE.headerTitle, hasArrow: ROUTE.headerHasArrow, backPath: "Main", theme })
        }}
      />
    </AccessTabNavigator.Navigator>
  );
});

export default AccessTabScreen;
